import styled from "styled-components";
import { useState } from "react";
import { gql, useQuery, useMutation } from "@apollo/client";
import { captureException } from "@sentry/react";
import { useNavigate } from "react-router-dom";

import * as css from "styles/CssVariables.js";
import LoadingBox from "components/other/LoadingBox";
import BoxLoadingSpinner from "components/other/BoxLoadingSpinner";
import SentEmailPreview from "./SentEmailPreview";
import SentResponderEmails from "./SentResponderEmails";
import Backdrop from "components/other/Backdrop";

const SentEmailsContainer = styled.div`
  margin-top: ${css.VERTICAL_BOX_MARGIN_MLARGE};
`;

const ModalWrap = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1000;
`;

export default ({ autoresponderId }) => {
  const [page, setPage] = useState(1);
  const [previewOpened, setPreviewOpened] = useState(false);
  const [previewingEmailHtml, setPreviewingEmailHtml] = useState(null);

  const limit = 10;

  // Fetch data
  const GET_SENT_RESPONDER_EMAILS_DATA = gql`
    query GetSentResponderEmailsData(
      $responderId: ID!
      $page: Int!
      $limit: Int!
    ) {
      sentResponderEmails(
        responderId: $responderId
        page: $page
        limit: $limit
      ) {
        emails {
          id
          created_at
          subject
          html
          lead {
            id
            name
            location_country
            email
          }
        }
        numOfResults
      }
    }
  `;

  const { data, error } = useQuery(GET_SENT_RESPONDER_EMAILS_DATA, {
    variables: {
      responderId: autoresponderId,
      page,
      limit,
    },
    skip: !autoresponderId,
    fetchPolicy: "network-only",
  });

  if (error) {
    console.log("error fetching sent responder emails data", error);
    captureException(error);
  }

  const paginate = (where) => {
    if (where === "previous") setPage((prevState) => prevState - 1);
    if (where === "next") setPage((prevState) => prevState + 1);
  };

  // handle Preview modal
  const onPreviewClick = (id) => {
    if (!data) return;

    const email = data.sentResponderEmails.emails.find(
      (email) => email.id === id
    );

    if (email) {
      setPreviewOpened(true);
      setPreviewingEmailHtml(email.html);
    }
  };

  const closePreview = () => {
    setPreviewOpened(false);
    setPreviewingEmailHtml(null);
  };

  //console.log("data", data);

  return (
    <SentEmailsContainer>
      {!data && (
        <LoadingBox>
          <BoxLoadingSpinner height="300px" />
        </LoadingBox>
      )}
      {data && (
        <SentResponderEmails
          data={data}
          page={page}
          limit={limit}
          paginate={paginate}
          onPreviewClick={onPreviewClick}
          closePreview={closePreview}
        />
      )}
      {previewOpened && (
        <ModalWrap>
          <Backdrop onClick={closePreview} background="rgba(0, 0, 0, 0.7)" />
          <SentEmailPreview
            subject="subject"
            html={previewingEmailHtml}
            closePreview={closePreview}
          />
        </ModalWrap>
      )}
    </SentEmailsContainer>
  );
};
